import { render } from "./PTable.vue?vue&type=template&id=01e747b7"
import script from "./PTable.vue?vue&type=script&lang=js"
export * from "./PTable.vue?vue&type=script&lang=js"

import "./PTable.vue?vue&type=style&index=0&id=01e747b7&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__